import { createTheme } from "@mui/material/styles";
import type { BrandTokens } from "../types";

export const createMinimalTheme = (brand: BrandTokens) =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: brand.primary },
      secondary: { main: brand.secondary },
      warning: { main: brand.accent },
      background: { default: "#ffffff", paper: "#ffffff" },
      text: { primary: brand.text, secondary: "rgba(11, 31, 39, 0.6)" }
    },
    shape: { borderRadius: Math.max(4, brand.radius - 4) },
    typography: {
      fontFamily: brand.fontFamily,
      h1: { fontWeight: 600, letterSpacing: "-0.01em", fontSize: "clamp(2rem, 3.2vw, 2.8rem)" },
      h2: { fontWeight: 600, fontSize: "clamp(1.6rem, 2.4vw, 2.1rem)" },
      h3: { fontWeight: 600, fontSize: "clamp(1.2rem, 1.9vw, 1.6rem)" },
      body1: { fontSize: "1rem", lineHeight: 1.7 },
      body2: { fontSize: "0.95rem", lineHeight: 1.7 },
      button: { textTransform: "none", fontWeight: 600 }
    },
    components: {
      MuiAppBar: {
        defaultProps: { color: "transparent", elevation: 0 }
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: "none", boxShadow: "none" } }
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: Math.max(4, brand.radius - 4), padding: "8px 18px" }
        }
      }
    }
  });
